<template>
    <div class="wndPrivilegeWraper">
        <!-- <div class="mask"></div> -->
        <div class="inner">
            <header-style-b :wndTitle="wndTitle"
                            @fnBtnClick="fnBtnClick" />
            <div class="wndPrivilege">
                <h3>使用易乐玩游戏盒子，可以享受一下特权</h3>
                <div class="block">
                    <div class="card">
                        <div class="img">
                            <img src="/resource/images/img_48x48_10.png"
                                 alt="新手福利" />
                        </div>
                        <div class="title">新手福利</div>
                        <div class="desc">
                            新注册账号，首次登录可领取满
                            <span class="colorfb674a">6减2</span>优惠券一张
                        </div>
                        <div class="group">
                            <a href="javascript:;"
                               class="btnPlayGame btnGet"
                               @click="fnFirstGet"
                               v-if="!isGetFirst"
                               v-text="btnTxt">立即领取</a>
                            <div class="gotIt"
                                 v-else>
                                <p>您已获得满6减2优惠券</p>
                                <p>
                                    请前往
                                    <a href="javascript:;"
                                       @click="fnOpenBrowser(privilegeInit.personal_url)">
                                        <span class="colorfb674a">个人中心</span>
                                    </a>查看
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="/resource/images/img_48x48_11.png"
                                 alt="每日充值优惠" />
                        </div>
                        <div class="title">每日充值优惠</div>
                        <div class="desc">
                            每日登录后即可领取满
                            <span class="colorfb674a">100减10</span>优惠券一张
                        </div>
                        <div class="group">
                            <a href="javascript:;"
                               class="btnPlayGame btnGet"
                               @click="fnGetDayWelfare"
                               v-if="!isGetDay"
                               v-text="btnTxt">立即领取</a>
                            <div class="gotIt"
                                 v-else>
                                <p>您已获得满100减10优惠券</p>
                                <p>
                                    请前往
                                    <a href="javascript:;"
                                       @click="fnOpenBrowser(privilegeInit.personal_url)">
                                        <span class="colorfb674a">个人中心</span>
                                    </a>查看
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="/resource/images/img_48x48_12.png"
                                 alt="微端全部特权" />
                        </div>
                        <div class="title">微端全部特权</div>
                        <div class="desc">使用盒子，可享受微端经验加成特权</div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="/resource/images/img_48x48_13.png"
                                 alt="专属礼包" />
                        </div>
                        <div class="title">专属礼包</div>
                        <div class="desc">
                            易乐玩游戏盒子专属
                            <span class="colorfb674a">超值礼包</span>
                        </div>
                        <div class="group flex"
                             style="align-items:center">
                            <a href="javascript:;"
                               class="btnPlayGame btnGet"
                               @click="fnGetGift">立即领取</a>
                            <a href="javascript:;"
                               class="colorfb674a"
                               @click="fnOpenBrowser(privilegeInit.giftUrl)"
                               style="font-size: 12px;white-space:nowrap;margin-left: 3px;text-decoration:underline">领取详情&gt;&gt;</a>
                        </div>
                    </div>
                    <div class="card">
                        <div class="img">
                            <img src="/resource/images/img_48x48_14.png"
                                 alt="免费领网费" />
                        </div>
                        <div class="title">免费领网费</div>
                        <div class="desc">
                            试玩游戏完成任务，免费
                            <span class="colorfb674a">领网费</span>
                        </div>
                        <div class="group">
                            <a :href="privilegeInit.netBarplay"
                               target="_blank"
                               class="btnPlayGame btnGet">前往试玩</a>
                        </div>
                    </div>
                    <div class="card waiting">
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>更多特权</p>
                        <p>敬请期待</p>
                    </div>
                </div>
            </div>
            <div class="bgfff wndGift"
                 v-if="wndGiftListClose">
                <div class="giftListTitle">
                    选择游戏
                    <a href="javascript:;"
                       @click="wndGiftListClose = !wndGiftListClose">&times;</a>
                </div>
                <loading v-if="!getGiftList" />
                <div v-else>
                    <div class="giftListContent"
                         :class="{'giftListContentResult': giftCode}">
                        <div v-if="!giftCode">
                            <h3>
                                请选择一款游戏领取
                                <span class="colorfb674a">专属礼包</span>
                            </h3>
                            <ul v-if="getGiftList.length > 0">
                                <li v-for="item in getGiftList"
                                    :key="item.id">
                                    <input type="radio"
                                           name="gift"
                                           :value="item.game_id"
                                           @change="fnGetGiftId({id: item.id, name: item.name})" />
                                    <label for="gift">{{item.name}}</label>
                                </li>
                            </ul>
                            <ul v-else>
                                <li>
                                    <empty-data>小编有点懒，游戏专属礼包尚未添加，稍候再试吧</empty-data>
                                </li>
                            </ul>
                            <div class="btnConfirm"
                                 v-if="getGiftList.length > 0">
                                <a href="javascript:;"
                                   class="btnPlayGame"
                                   @click="fnGetGiftConfirm">立即领取</a>
                            </div>
                        </div>
                        <div v-else>
                            <h3>恭喜您成功领取{{giftGame}}超值礼包</h3>
                            <div class="group">
                                <span>礼包兑换码：</span>
                                <input type="text"
                                       disabled
                                       v-model="giftCode" />
                                <a href="javascript:;"
                                   class="btnCopy"
                                   data-clipboard-action="copy"
                                   :data-clipboard-text="giftCode">复制</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../store'
import HeaderStyleB from '../common/HeaderStyleB'
import Loading from '../common/Loading'
import EmptyData from '@/common/EmptyData'

export default {
    name: 'WndPrivilege',
    data () {
        return {
            msg: 'WndPrivilege',
            wndTitle: '易乐玩游戏盒子特权',
            isGetFirst: false,
            isGetDay: false,
            privilegeInit: '',
            toPlay: '',
            getGiftList: null,
            btnClick: true,
            wndGiftListClose: false,
            giftId: 0,
            giftGame: null,
            giftCode: null,
            btnFastClick: false,
            btnTxt: '立即领取'
        }
    },
    components: {
        HeaderStyleB,
        Loading,
        EmptyData
    },
    watch: {},
    created () {
        this.fnWelfareInit()
    },
    mounted () {
        let clipboard = new this.Clipboard('.btnCopy')
        clipboard.on('success', () => {
            this.Toast({
                content: '复制成功'
            })
        })
        clipboard.on('error', () => {
            this.Toast({
                content: '复制失败'
            })
        })
    },
    methods: {
        // 打开默认浏览器
        fnOpenBrowser (u) {
            this.fnCefGameBox({
                method: 'clientOpenBrowser',
                data: {
                    url: u
                }
            })
        },
        // 礼包ID
        fnGetGiftId (o) {
            this.giftId = o.id
            this.giftGame = o.name
        },
        // 确认领取专属礼包
        fnGetGiftConfirm () {
            if (!this.btnClick) return
            this.btnClick = false
            this.wndGiftListClose = true
            this.XHR({
                url: this.ports.welfare.gift,
                data: {
                    id: this.giftId,
                    token: store.state.USER.box_token
                },
                cbFn: (res) => {
                    this.btnClick = true
                    if (res.status === 'error') {
                        this.Toast({
                            content: res.info
                        })
                        return
                    }
                    this.giftCode = res.data.cardCode
                }
            })
        },
        // 专属礼包
        fnGetGift () {
            if (!this.btnClick) return
            this.btnClick = false
            this.wndGiftListClose = true
            this.giftCode = null
            this.giftId = null
            this.XHR({
                url: this.ports.welfare.giftList,
                data: {
                    token: store.state.USER.box_token
                },
                cbFn: (res) => {
                    this.btnClick = true
                    if (res.status === 'error') return
                    this.getGiftList = res.data.list
                }
            })
        },
        // 福利按钮初始化
        fnWelfareInit () {
            if (this.privilegeInit) return
            this.XHR({
                url: this.ports.welfare.init,
                data: {
                    token: store.state.USER.box_token
                },
                cbFn: (res) => {
                    if (res.status === 'error') return
                    this.privilegeInit = res.data
                    if (this.privilegeInit.newUser === 1) {
                        this.isGetFirst = true
                    }
                    if (this.privilegeInit.dayWelfare === 1) {
                        this.isGetDay = true
                    }
                }
            })
        },
        fnBtnClick () {
            this.$emit('fnBtnClick', 'privilege')
        },
        // 新手福利
        fnFirstGet () {
            if (this.btnFastClick) return
            this.btnFastClick = true
            this.XHR({
                url: this.ports.welfare.exclusive,
                data: {
                    token: store.state.USER.box_token
                },
                cbFn: (res) => {
                    this.btnFastClick = false
                    if (res.status === 'error') return
                    this.Toast({
                        content: '领取成功'
                    })
                    this.isGetFirst = true
                }
            })
        },
        // 每日充值优惠
        fnGetDayWelfare () {
            if (store.state.welfare.day && store.state.welfare.day.val) {
                this.Toast({
                    content: store.state.txt.welfareDay,
                    time: 3000
                })
                return
            }
            if (this.btnFastClick) return
            this.btnFastClick = true
            this.XHR({
                url: this.ports.welfare.day,
                data: {
                    token: store.state.USER.box_token
                },
                cbFn: (res) => {
                    this.btnFastClick = false
                    this.Toast({
                        content: res.info,
                        time: 3000
                    })
                    if (res.status === 'error') return
                    this.$store.commit('STATEFN', {
                        dataType: 'welfare',
                        day: {
                            val: true,
                            info: res.info
                        }
                    })
                    this.isGetDay = true
                }
            })
        }
    }
}
</script>

<style scoped>
.mask {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 71;
  width: 100%;
  height: calc(100% - 60px);
  background: rgba(0, 0, 0, 0.08);
}

.wndPrivilegeWraper .inner {
  width: 730px;
  height: 650px;
  border: 1px solid rgb(204, 204, 204);
  background-color: rgb(238, 238, 238);
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 72;
  transform: translate(-50%, -50%);
}

.wndPrivilege {
  padding: 25px;
  color: #888;
  font-size: 14px;
}

.wndPrivilege h3 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 16px;
  color: #555;
}

.block {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
}

.card {
  width: 190px;
  height: 239px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 20px 25px;
  margin-bottom: 25px;
  margin-right: 53px;
}

.waiting {
  background: transparent;
  text-align: center;
  font-size: 18px;
}

.waiting p {
  margin-top: 7px;
}

.card:nth-child(3),
.card:nth-child(6) {
  margin-right: 0;
}

.title {
  font-size: 18px;
  color: #555;
  margin: 5px 0 10px;
}

.desc {
  min-height: 63px;
}

.btnGet {
}

.gotIt {
  font-size: 12px;
}

.gotIt p {
  margin: 0 0 2px;
}

.colorfb674a {
  color: #fb674a;
}

.wndGift {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 560px;
  height: 310px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #ddd;
}

.giftListTitle {
  height: 40px;
  line-height: 40px;
  background: #eee;
  position: relative;
  text-indent: 10px;
}

.giftListTitle a {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 22px;
  text-align: center;
  text-indent: 0;
  color: #888;
}

.giftListTitle a:hover {
  color: #f00;
}

.giftListContent {
  padding: 20px;
}

.giftListContent h3 {
  margin-top: 0;
}

.giftListContent ul {
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  height: 150px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 15px;
}

.giftListContent li {
  width: 24%;
  margin-right: 1%;
  position: relative;
  margin-bottom: 5px;
  height: 25px;
  line-height: 25px;
}

.giftListContent input[name='gift'] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 7;
  opacity: 0;
  cursor: pointer;
}

.giftListContent label {
  position: relative;
  padding-left: 18px;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  z-index: 1;
}

.giftListContent label:before,
.giftListContent label:after {
  content: ' ';
  position: absolute;
  background: #fff;
  top: 50%;
  border-radius: 50%;
  transition: all 0.1s ease-in-out;
}

.giftListContent label:before {
  width: 12px;
  height: 12px;
  border: 1px solid #aaa;
  left: 0;
  margin-top: -7px;
}

.giftListContent label:after {
  width: 8px;
  height: 8px;
  left: 2px;
  margin-top: -5px;
  transform: scale(0);
  transform-origin: center;
  transition: transform 0.2s ease-in-out;
}

.giftListContent li:hover label {
  width: 160%;
  background: #fff;
  z-index: 3;
  box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.1);
}

.giftListContent input:checked ~ label:before {
  border-color: #f59c12;
}

.giftListContent input:checked ~ label:after {
  transform: scale(1);
  background: #f59c12;
}

.giftListContent li:nth-child(4n) {
  margin-right: 0;
}

.btnConfirm {
  text-align: center;
}

.giftListContent .group {
  display: flex;
  flex-flow: row;
  text-align: center;
  align-items: center;
  justify-content: center;
}

.giftListContentResult {
  text-align: center;
}

.giftListContentResult input {
  width: 260px;
  height: 32px;
  padding: 0 5px;
}

.giftListContentResult input:disabled {
  background: #fff;
  border: 1px solid #ddd;
  border-right: 0;
}

.giftListContentResult .btnCopy {
  width: 50px;
  height: 32px;
  background: #d8ac78;
  color: #fff;
  line-height: 32px;
  text-align: center;
}

.giftListContentResult h3 {
  margin-top: 55px;
  margin-bottom: 30px;
}
</style>
